/** @format */

import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import Navbar from "../../../../shared/components/navbar";
import Footer from "../../../../shared/components/footer";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import ReportClaimForm from "../../components/reportClaim/reportClaimForm";
import ERSClaimSection from "../../components/reportClaim/ErsClaimSection";

const ReportClaimLayout = () => {
  const css = assetUrl("../../../../styles/landing.css");
  const STATE = useAppStateStore();
  const insurer = STATE.customerPolicies?.customerPolicies?.[0]?.insurer;

  return (
    <>
      <Helmet>
        <link rel="stylesheet" href={css} />
      </Helmet>
      <Navbar />
      <main className="mainBody">
        {insurer === "ERS" ? <ERSClaimSection /> : <ReportClaimForm />}
      </main>
      <Footer />
    </>
  );
};

export default ReportClaimLayout;
